/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActiveSuspension } from './ActiveSuspension';
import {
    ActiveSuspensionFromJSON,
    ActiveSuspensionFromJSONTyped,
    ActiveSuspensionToJSON,
    ActiveSuspensionToJSONTyped,
} from './ActiveSuspension';

/**
 * 
 * @export
 * @interface MatchOperationsState
 */
export interface MatchOperationsState {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsState
     */
    matchId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsState
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    period?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    elapsedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    effectiveElapsedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    periodElapsedMs?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationsState
     */
    clockRunning?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    scoreTeamA?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    scoreTeamB?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    teamATimeouts?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    teamBTimeouts?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsState
     */
    lastServerSequence?: number;
    /**
     * 
     * @type {Date}
     * @memberof MatchOperationsState
     */
    lastEventAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MatchOperationsState
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatchOperationsState
     */
    allowedCommands?: Array<string>;
    /**
     * 
     * @type {Array<ActiveSuspension>}
     * @memberof MatchOperationsState
     */
    activeSuspensions?: Array<ActiveSuspension>;
}

/**
 * Check if a given object implements the MatchOperationsState interface.
 */
export function instanceOfMatchOperationsState(value: object): value is MatchOperationsState {
    return true;
}

export function MatchOperationsStateFromJSON(json: any): MatchOperationsState {
    return MatchOperationsStateFromJSONTyped(json, false);
}

export function MatchOperationsStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsState {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'status': json['status'] == null ? undefined : json['status'],
        'period': json['period'] == null ? undefined : json['period'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'effectiveElapsedMs': json['effectiveElapsedMs'] == null ? undefined : json['effectiveElapsedMs'],
        'periodElapsedMs': json['periodElapsedMs'] == null ? undefined : json['periodElapsedMs'],
        'clockRunning': json['clockRunning'] == null ? undefined : json['clockRunning'],
        'scoreTeamA': json['scoreTeamA'] == null ? undefined : json['scoreTeamA'],
        'scoreTeamB': json['scoreTeamB'] == null ? undefined : json['scoreTeamB'],
        'teamATimeouts': json['teamATimeouts'] == null ? undefined : json['teamATimeouts'],
        'teamBTimeouts': json['teamBTimeouts'] == null ? undefined : json['teamBTimeouts'],
        'lastServerSequence': json['lastServerSequence'] == null ? undefined : json['lastServerSequence'],
        'lastEventAt': json['lastEventAt'] == null ? undefined : (new Date(json['lastEventAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'allowedCommands': json['allowedCommands'] == null ? undefined : json['allowedCommands'],
        'activeSuspensions': json['activeSuspensions'] == null ? undefined : ((json['activeSuspensions'] as Array<any>).map(ActiveSuspensionFromJSON)),
    };
}

export function MatchOperationsStateToJSON(json: any): MatchOperationsState {
    return MatchOperationsStateToJSONTyped(json, false);
}

export function MatchOperationsStateToJSONTyped(value?: MatchOperationsState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'status': value['status'],
        'period': value['period'],
        'elapsedMs': value['elapsedMs'],
        'effectiveElapsedMs': value['effectiveElapsedMs'],
        'periodElapsedMs': value['periodElapsedMs'],
        'clockRunning': value['clockRunning'],
        'scoreTeamA': value['scoreTeamA'],
        'scoreTeamB': value['scoreTeamB'],
        'teamATimeouts': value['teamATimeouts'],
        'teamBTimeouts': value['teamBTimeouts'],
        'lastServerSequence': value['lastServerSequence'],
        'lastEventAt': value['lastEventAt'] == null ? value['lastEventAt'] : value['lastEventAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'allowedCommands': value['allowedCommands'],
        'activeSuspensions': value['activeSuspensions'] == null ? undefined : ((value['activeSuspensions'] as Array<any>).map(ActiveSuspensionToJSON)),
    };
}

